import styled from "styled-components";
import theme from "./../../styles/theme"

export const PolicySustainabilitysection = styled.section`
  position: relative;
  margin-bottom: 150px;
  height: 850px;

  @media (max-width: 1500px){
    margin-bottom: 0px;
  }

  @media (max-width:  ${theme.breakpoints.medium}){
    margin: 0;
    height: 100%;
  }
`;

export const SecondBackgroud = styled.div`
  position: absolute;
  width: 75%;
  right: -65%;
  height: 100%;
`;


export const PolicySustainabilityBox = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  top: 35px;
  flex-direction: row-reverse;
  width: 548px;
  left: calc(25% - 0px);

  @media (max-width: 1700px) {
    left: calc(20% - 0px);
  }
  @media (max-width: 1600px) {
    left: calc(15% - 0px);
  }
  @media (max-width: 1500px) {
    left: calc(10% - 0px);
  }
  @media (max-width:  ${theme.breakpoints.medium}) {
    position: initial;
    margin-top: -70px;
    width: 100%;
  }
`;
export const PolicySustainabilityWrapper = styled.div`
`;


export const PolicySustainabilityTitle = styled.h3`
  color: ${theme.colors.white};
  font-family: ${theme.fonts.montSerrat};
  font-size: 51px;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 62px;
  text-align: left;
  text-transform: uppercase;

  @media (max-width:  ${theme.breakpoints.medium}) {
    position: absolute;
    top: 20px;
    font-size: 26px;
    padding: 0px 40px 0 46px;
    text-align: left;
  }
`;

export const PolicySustainabilitySubTitle = styled.h3`
  color: ${theme.colors.white};
  font-family: ${theme.fonts.montSerrat};
  font-size: 51px;
  font-style: normal;
  font-weight: 800 !important;
  line-height: 62px;
  padding-bottom: 20px;
  text-align: left;
  text-transform: uppercase;

  @media (max-width:  ${theme.breakpoints.medium}) {
    position: absolute;
    top: 55px;
    font-size: 26px;
    padding: 0px 40px 0 46px;
    text-align: left;
  }
`;

export const PolicySustainabilityCard = styled.div`
  background: ${theme.colors.white};
  border: 1px solid rgba(225, 225, 225, 0.3);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding: 20px 45px;
  text-align: left;

  @media (max-width:  ${theme.breakpoints.medium}){
    box-shadow: none;
    border: none;
    background-color: transparent;
  }
`;

export const PolicySustainabilityDescription = styled.p`
  font-family: ${theme.fonts.montSerrat};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 15px 0px;
`;

export const PolicySustainabilityLink = styled.a`
  font-weight: ${theme.fontWeights.bold};
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.gray};
`;
